<template>
    <span class="butaca"
          :class="getStatusClasses(asiento)"
          @click="$emit('toggle')" :title="getTitle(asiento, fila)"
          @contextmenu="showContextMenu"
    >
        <span>{{ asiento.asiento }}</span>
    </span>
</template>

<script>
export default {
    props: {
        asiento: Object,
        fila: String,
        front: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getStatusClasses(asiento) {
            if(asiento.oculto > 0) {
                return {
                    'seleccionada' : asiento.seleccionado,
                    'oculto': asiento.oculto === 1,
                    'columna': asiento.oculto == 2,
                    'columna_n': asiento.oculto == 3
                };
            }

            if(this.front) {
                return {
                    'ocupada' : asiento.ocupado,
                    'seleccionada' : asiento.seleccionado,
                    'libre' : !asiento.ocupado
                };
            } else {
                return {
                    'ocupada' : asiento.ocupado === 1 || asiento.ocupado === true,
                    'pendiente' : asiento.ocupado === 2,
                    'seleccionada' : asiento.seleccionado,
                    'libre' : asiento.ocupado === 0 || asiento.ocupado === false,
                    'bloqueada': asiento.ocupado === 3,
                    "abonado": (asiento.ocupado === 1 || asiento.ocupado === true) && asiento.info && (asiento.info.es_abonado || asiento.info.abonado_lista_abonado_id > 0) && asiento.info.n_abonado >= 0,
                };
            }                
        },
        getTitle(asiento, fila) {

            if(this.front){
                return 'Fila: ' + fila + ' Butaca: ' + asiento.asiento;
            }

            if(asiento.ocupado === 3 || (asiento.info && asiento.info.concepto != null)) {
                return 'Concepto: ' + (asiento.info ? asiento.info.concepto : '');
            } else {
                var text = '';

                text = text + 'Fila: ' + fila + ' Butaca: ' + asiento.asiento;

                if(asiento.info) {
                    if(asiento.info.n_abonado) {
                        text = text + ' Nº Abonado: ' + asiento.info.n_abonado;
                    }

                    if(asiento.info.name) {
                        text = text + ' Nombre: ' + asiento.info.name;
                    }

                    if(asiento.info.surnames) {
                        text = text + ' ' + asiento.info.surnames;
                    }

                    if(asiento.info.telefono) {
                        text = text + ' Telefono: ' + asiento.info.telefono
                    }
                }

                if(asiento.lfp_id) {
                    text = text + ' Lfp ID: ' + asiento.lfp_id;
                }
                return text;
            }
        },
        showContextMenu(event) {
            event.preventDefault();
            this.$emit('menu', event.clientY, event.clientX, this.asiento);
        },
    },
}
</script>

<style>
    .butaca {
        width: 16px;
        height: 15px;
        margin-right: 3px;
        margin-bottom: 1px;
        line-height: 2.3;
        border-radius: 0 0 4px 4px;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        font-size: 7px;
    }
    .butaca.libre {
        background: rgb(169, 209, 146);
    }
    .butaca.ocupada, .butaca.ocupada a {
        background-color: #CC0000;
        color: white;
    }
    .butaca.seleccionada {
        background-color: #8CA9D9;
    }
    .butaca.pendiente {
        background-color: #EAAA00;
    }
    .butaca.bloqueada {
        background-color: #bf95c4;
    }
    .butaca.abonado {
        background-color: black !important;
    }
</style>
